import { x } from '@xstyled/styled-components';
import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';
import { useTransition } from '@react-spring/web';
import { Toast } from './Toast';
import { useToastStore } from './toastStore';
import { ToastDefinition } from './types';

export const Toasts = () => {
  const toasts = useToastStore(s => s.toasts);
  const refMap = useMemo(() => new WeakMap(), []);

  const filteredToasts = toasts.reduce(
    (filteredToasts: ToastDefinition[], currentToast) => {
      if (
        !filteredToasts.find(
          (toast: ToastDefinition) => toast.message === toast.message
        )
      ) {
        filteredToasts.push(currentToast);
      }
      return filteredToasts;
    },
    []
  );

  const transitions = useTransition(filteredToasts, {
    from: { opacity: 0, height: 0 },
    enter: item => async next => {
      await next({ opacity: 1, height: refMap.get(item).offsetHeight });
    },
    leave: [{ opacity: 0 }, { height: 0 }],
    keys: i => i.id!
  });

  return createPortal(
    <x.div
      position="fixed"
      top="0"
      right="0"
      bottom="0"
      w="450px"
      pointerEvents="none"
      zIndex="99999"
    >
      <x.div maxH="100%" overflowY="auto" pointerEvents="all" paddingRight="md">
        {transitions((style, item) => (
          <Toast
            style={style}
            toast={item}
            ref={(ref: HTMLDivElement) => ref && refMap.set(item, ref)}
          />
        ))}
      </x.div>
    </x.div>,
    document.body
  );
};
